// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slide-meta-app-parent {    
    width: 56px;
    padding-left: 16px;
    padding-right:16px;
}

.app-heading {
    text-align: center;
    margin: 5px;
}

.center-align {
    text-align: center;
}

.top-row-margin {
    margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/neotileviewer/slide_meta_app.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".slide-meta-app-parent {    \n    width: 56px;\n    padding-left: 16px;\n    padding-right:16px;\n}\n\n.app-heading {\n    text-align: center;\n    margin: 5px;\n}\n\n.center-align {\n    text-align: center;\n}\n\n.top-row-margin {\n    margin-top: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
